import { isKnownArtist } from './isKnownArtist'

export const getArtworkSubtitle = (artistname, galleryName) => {
  if (!isKnownArtist(artistname)) return galleryName ?? null
  return artistname
}